import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';

const Forgot = () => {
  const navigate = useNavigate();
  
  const serverHost = process.env.REACT_APP_SERVER_HOST
  
  const navigateTo = (path, userData = null) => {
    if (userData) {
      navigate(path, { state: { userData } });
    } else {
      navigate(path);
    }
  };

  const [email, setEmail] = useState('');

  const location = useLocation();

  useEffect(() => {
    if (location.state && location.state.email) {
      setEmail(location.state.email);
    }
  }, [location.state]);
  
  const [waiting, setWaiting] = useState(false);

  const handleProceed = async (event) => {
    event.preventDefault();

    try {
      setWaiting(true);

      const response = await fetch(`${serverHost}/find-user?email=${email}`, {
        method: 'GET'
      });

      const result = await response.json();

      if (response.status === 200) {
        const userData = {
          otp_id: result.otp_id,
          user_id: result.user_id
        };
        navigateTo('/email-verification', userData);
      } else {
        Swal.fire({
          title: 'Failed to sign up',
          text: result.error,
          icon: 'error',
          confirmButtonText: 'Close',
        });
      }
    } catch (error) {
      Swal.fire({
        title: 'Failed to submit the form',
        text: error,
        icon: 'error',
        confirmButtonText: 'Close',
      });
    } finally {
      setWaiting(false); // Stop the spinner, whether successful or not
    }
  };

  return (
    <Container>
      <FormContainer>
        <LabelContainer>
          <Logo src="images/connectkgp.png" alt="connectKGP" />
          <Title>Find Your Account</Title>
        </LabelContainer>
        <ImageContainer>
          <img src="images/otp.png" alt="OTP Icon" />
        </ImageContainer>
        <Form id="emailForm">
          <EmailInput>
            <InputLabel>Registered Email</InputLabel>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete='off'
              required
            />
          </EmailInput>
          <ProceedButton onClick={handleProceed} disabled={waiting}>{waiting ? <i className='fa fa-spinner' />:'Proceed'}</ProceedButton>
        </Form>
      </FormContainer>
    </Container>
  );
};

export default Forgot;

const Container = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 92vh;
  background-color: white;
`;

const FormContainer = styled.div`
  margin: auto auto;
  position: relative;
  width: 25%;
  background: rgba(217, 217, 217, 0.5);
  box-shadow: rgba(0, 0, 0, 0.2) -5px 5px 0px;

  @media only screen and (max-width: 600px) {
    width: 90%;
  }
`;

const LabelContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  background: #6559a2;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  justify-content: center;
  align-items: center;
`;

const Logo = styled.img`
  height: 50px;
`;

const Title = styled.p`
  color: white;
  font-size: 20px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: transparent;
  padding-top: 20px;
  text-align: center;
`;

const ImageContainer = styled.div`
  text-align: center;
  background: transparent;
  padding: 0 20px;
  
  img {
    margin-top: 20%;
    background: transparent;
  }
`;

const InputLabel = styled.span`
`;

const Input = styled.input`
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
`;

const ProceedButton = styled.button`
  margin-top: 50px;
  margin-bottom: 20px;
  padding: 10px 25px;
  background: #6559a2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  box-shadow: rgba(0, 0, 0, 0.2) -3px 3px 0px;


  &:disabled {
    background: #d9d9d9;
    cursor: default;
    color: #6559a2;
    font-weight: bold;
  }

  i {
    animation: rotation 2s infinite linear;
  }

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`;

const EmailInput = styled.div`
  display: flex;
  width: 20vw;
  gap: 20px;
  justify-content: center;
  align-items: center;
`;